import { Search } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material/styles';

function SearchTxtField({ searchKeyWord, onSearch, placeholder, onBtnClick, variant }) {
    const theme = useTheme();
    return (
        <Box width={250}>
            <TextField variant={variant ? variant : "outlined"} fullWidth type={"search"}
                value={searchKeyWord}
                onChange={onSearch && onSearch}
                sx={{ "& .MuiInputBase-root": { height: 30, borderRadius: 10, fontSize: 13 } }}
                placeholder={placeholder}
                InputProps={onBtnClick ? {
                    endAdornment: (
                        <InputAdornment position={"end"} >
                            <IconButton onClick={onBtnClick} sx={{ color: theme.palette.otherColors.btn }}>
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    ),
                    style: { paddingLeft: 3, paddingRight: 3 },
                } : {
                    startAdornment: (
                        <InputAdornment position={"start"}>
                            <IconButton color='secondary'>
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    ),
                    style: { paddingLeft: 3, paddingRight: 6 },
                }}
            />
        </Box>
    )
}
export default SearchTxtField